<template>
    <ModalContent
        class="enterprise-split-modal-shell"
        :help-content-id="`popup-order-${current_entity_profile}`"
        flat-chrome
    >
        <template slot="title">{{ title }}</template>
        <template slot="rawcontent">
            <div class="enterprise-split-modal enterprise-split-modal--stitch general-settings-reference">
                <div
                    class="enterprise-split-modal__body d-flex flex-column flex-md-row flex-grow-1 flex-shrink-1 min-height-0"
                >
                    <section class="enterprise-split-modal__form order-edit-column d-flex flex-column">
                        <div class="stitch-modal stitch-modal--split">
                            <v-card class="stitch-modal__card" elevation="0"><v-card-text>
                            <h5 class="stitch-modal__title"><v-icon size="16">mdi-cart-outline</v-icon><span>{{ $translate("orderSection") }}</span></h5>
                            <div class="stitch-modal__stack">
                            <DateTime
                                :value="order.order_date"
                                :label="$translate('orderDateLabel')"
                                :error-messages="order_saving_errors?.order_date"
                                :only-date="true"
                                dense
                                outlined
                                :min-date="null"
                                hide-details="auto"
                                @input="updateOrderDate($event)"
                            />
                            <div>
                                <SearchCustomer
                                    :key="buyer_id"
                                    :value="buyer_id"
                                    :error-messages="order_saving_errors?.customer"
                                    :allow-create="true"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    @input="setBuyerAction($event)"
                                />
                                <v-alert
                                    v-if="
                                        buyer_id &&
                                        buyer_id !== 'new' &&
                                        overdue_invoices_stats &&
                                        overdue_invoices_stats.invoices > 0 &&
                                        userHasPermission('billing.view_invoice')
                                    "
                                    type="warning"
                                    dense
                                    text
                                    class="mt-4"
                                >
                                    <small>
                                        {{ overdueUnpaidInvoicesMessage }}
                                        <a
                                            href="#"
                                            class="primary--text ml-1 text-decoration-none"
                                            @click.prevent="goToCustomerInvoices"
                                        >
                                            {{ $translate("view") }}
                                        </a>
                                    </small>
                                </v-alert>
                            </div>
                            <template v-if="showAssignToField">
                                <SearchUser
                                    :value="order.assigned_to"
                                    :error-messages="order_saving_errors.assigned_to"
                                    :label="$translate('labels.assignedTo')"
                                    :dense="true"
                                    outlined
                                    hide-details="auto"
                                    @input="updateAssignedTo($event)"
                                    :additional-params="{
                                        entity: current_entity_id,
                                        impersonification: false,
                                        is_active: true,
                                    }"
                                />
                            </template>
                            <template v-if="showComments">
                                <v-textarea
                                    v-model="order.comments"
                                    :error-messages="order_saving_errors.comments"
                                    :label="$translate('labels.comments')"
                                    :placeholder="$translate('placeholders.comments')"
                                    :disabled="order.readonly"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :rows="2"
                                />
                            </template>
                            <template v-if="showNotes">
                                <v-textarea
                                    v-model="order.notes"
                                    :error-messages="order_saving_errors.notes"
                                    :label="$translate('labels.notes')"
                                    :placeholder="$translate('placeholders.notes')"
                                    dense
                                    outlined
                                    :rows="2"
                                    hide-details="auto"
                                />
                            </template>

                            <div
                                v-if="
                                    !showComments ||
                                    !showNotes
                                "
                                class="enterprise-split-modal__expand-list"
                            >
                                <button
                                    v-if="!showComments && !order.readonly"
                                    type="button"
                                    class="enterprise-split-expand"
                                    @click="showComments = true"
                                >
                                    <span class="enterprise-split-expand__icon-wrap">
                                        <v-icon size="14">mdi-plus</v-icon>
                                    </span>
                                    <span class="enterprise-split-expand__label">{{
                                        $translate("buttons.addComments")
                                    }}</span>
                                </button>

                                <button
                                    v-if="!showNotes"
                                    type="button"
                                    class="enterprise-split-expand"
                                    @click="showNotes = true"
                                >
                                    <span class="enterprise-split-expand__icon-wrap">
                                        <v-icon size="14">mdi-plus</v-icon>
                                    </span>
                                    <span class="enterprise-split-expand__label">{{
                                        $translate("buttons.addNotes")
                                    }}</span>
                                </button>
                            </div>
                            </div></v-card-text></v-card>
                        </div>
                    </section>
                    <section class="enterprise-split-modal__form order-edit-column d-flex flex-column">
                        <div class="stitch-modal stitch-modal--split">
                            <v-card class="stitch-modal__card" elevation="0"><v-card-text>
                            <h5 class="stitch-modal__title"><v-icon size="16">mdi-truck-outline</v-icon><span>{{ $translate("shippingSection") }}</span></h5>
                            <Placeholder
                                v-if="!buyer_id || buyer_id === 'new'"
                                :title="$translate('selectCustomerForShipping')"
                                :description="$translate('selectCustomerForShippingHint')"
                                :min-height="180"
                                :width="56"
                                no-padding
                            />
                            <div v-else class="stitch-modal__stack">
                            <template v-if="buyer_id && buyer_id !== 'new'">
                                <v-select
                                    :value="order_type"
                                    :items="order_typechoices"
                                    item-text="text"
                                    item-value="value"
                                    :label="$translate('labels.deliveryMode')"
                                    :disabled="order.readonly"
                                    
                                    dense
                                    outlined
                                    hide-details="auto"
                                    @input="setOrderTypeAction"
                                />
                            </template>
                            <DateTime
                                v-if="order_type !== 'no_delivery'"
                                :value="delivery_date"
                                :label="$translate(order_type === 'pickup' ? 'labels.pickupDate' : 'labels.deliveryDate')"
                                :error-messages="order_saving_errors?.delivery_date"
                                :only-date="true"
                                dense
                                outlined
                                :min-date="null"
                                :disabled="order.readonly"
                                hide-details="auto"
                                @input="updateDeliveryDate($event)"
                            />
                            <template v-if="order_type == 'shipping' && buyer_id">
                                <div class="d-flex align-start">
                                    <v-btn
                                        v-if="activeDeliverySite?.owner == current_entity_id"
                                        small
                                        class="mr-2 flex-shrink-0"
                                        @click="editSite"
                                        :title="$translate('editSite')"
                                        style="min-width: 30px; width: 30px; height: 30px"
                                    >
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-select
                                        :value="deliverysite_id"
                                        @input="setDeliverySiteIdAction($event)"
                                        :error-messages="order_saving_errors.deliverysite"
                                        :label="$translate('labels.deliverySite')"
                                        :disabled="deliverysites_loading"
                                        :items="deliverysiteschoices"
                                        :loading="deliverysites_loading"
                                        :key="Math.random()"
                                        class="flex-grow-1"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    />
                                </div>
                                <div
                                    v-if="deliverysiteschoices.length == 0"
                                    class="grey--text font-italic text-caption"
                                >
                                    {{ $translate("noDeliverySite") }}
                                </div>
                            </template>
                            <template v-if="showDeliveryInstructions">
                                <v-textarea
                                    v-model="order.delivery_instructions"
                                    :error-messages="
                                        order_saving_errors.delivery_instructions
                                    "
                                    :label="$translate('labels.delivery_instructions')"
                                    :placeholder="
                                        $translate('placeholders.delivery_instructions')
                                    "
                                    :disabled="order.readonly"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    :rows="2"
                                />
                                <v-alert
                                    v-if="showDeliveryInstructionsWarning"
                                    type="info"
                                    dense
                                    text
                                    class="mb-0 enterprise-split-modal__alert-after-textarea"
                                >
                                    <small>{{ $translate("delivery_update_warning") }}</small>
                                </v-alert>
                            </template>
                                <button
                                    v-if="
                                        !showDeliveryInstructions && !order.readonly
                                    "
                                    type="button"
                                    class="enterprise-split-expand"
                                    @click="showDeliveryInstructions = true"
                                >
                                    <span class="enterprise-split-expand__icon-wrap">
                                        <v-icon size="14">mdi-plus</v-icon>
                                    </span>
                                    <span class="enterprise-split-expand__label">{{
                                        $translate("buttons.addDeliveryInstructions")
                                    }}</span>
                                </button>
                            </div></v-card-text></v-card>
                        </div>
                    </section>
                </div>
            </div>
        </template>
        <template slot="bottom">
            <Button
                class="enterprise-split-modal__footer-cancel my-2 my-sm-4 w-100 w-sm-auto"
                :text="$translate('buttons.cancel')"
                ghost
                @click="hideModal"
            />
            <Button
                :text="saveText"
                class="enterprise-split-modal__footer-save my-2 my-sm-4 w-100 w-sm-auto ml-sm-4"
                :disabled="!canSave"
                :key="JSON.stringify(order)"
                @click="saveInformationClicked"
            />
        </template>

    </ModalContent>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import CreateCustomer from "@/modals/customer.vue";
import DeliverySiteModal from "@/modals/deliverysite";
import GlobalMixins from "@/mixins/global";

/** Matches Tailwind `max-w-4xl` for the global modal shell (`components/modal/modal.vue`). */
const MODAL_MAX_WIDTH = 896;

export default {
    maxWidth: MODAL_MAX_WIDTH,
    scrollable: false,
    mixins: [GlobalMixins],
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showCommentsField: false,
            showDeliveryInstructionsField: false,
            showNotesField: false,
            overdue_invoices_stats: null,
        };
    },
    computed: {
        showComments: {
            get() {
                return this.showCommentsField || !!this.order.comments;
            },
            set(value) {
                this.showCommentsField = value;
            },
        },
        showDeliveryInstructions: {
            get() {
                return (
                    this.showDeliveryInstructionsField ||
                    !!this.order.delivery_instructions
                );
            },
            set(value) {
                this.showDeliveryInstructionsField = value;
            },
        },
        showNotes: {
            get() {
                return this.showNotesField || !!this.order.notes;
            },
            set(value) {
                this.showNotesField = value;
            },
        },
        overdueUnpaidInvoicesMessage() {
            if (
                !this.overdue_invoices_stats ||
                this.overdue_invoices_stats.invoices <= 0
            ) {
                return "";
            }
            const count = this.overdue_invoices_stats.invoices;
            const amount = this.$utils.formatNumberLocale(
                this.overdue_invoices_stats.amount_due ?? this.overdue_invoices_stats.total_amount_incl_vat
            );
            const template = this.$translate(
                "overdueUnpaidInvoicesWarningCompact"
            );
            return template
                .replace("{{count}}", String(count))
                .replace("{{amount}}", amount);
        },
        ...mapState("editcustomerorder", [
            "order",
            "order_type",
            "order_saving",
            "order_saving_errors",
            "delivery_date",
            "deliverysites",
            "buyer",
            "buyers",
            "buyer_id",
            "seller_id",
            "deliverysite",
            "deliverysite_id",
            "buyers_loading",
            "deliverysites_loading",
        ]),
        ...mapState("settings", ["settings"]),
        saveText() {
            if (this.isNew) {
                return this.$translate("buttons.createOrder");
            }
            return this.$translate("buttons.saveOrder");
        },
        buyerschoices() {
            let choices = this.buyers.map((item) => ({
                value: item.id,
                text: item.name,
            }));
            return [
                {
                    value: "new",
                    text: this.$translate("buttons.createNewCustomer"),
                },
            ].concat(choices);
        },
        deliverysiteschoices() {
            let choices = [];
            if (!this.buyer?.entity) {
                choices.push({
                    value: "new",
                    text: this.$translate("buttons.createNewSite"),
                });
            }

            if (this.deliverysites) {
                return choices.concat(
                    this.deliverysites.map((item) => ({
                        value: item.id,
                        text: item.default
                            ? `${this.getDeliverySiteName(item)} (${this.$translate(
                                  "labels.defaultDeliverySite"
                              )})`
                            : this.getDeliverySiteName(item),
                    }))
                );
            }
            return choices;
        },
        activeDeliverySite() {
            if (!this.deliverysites) {
                return null;
            }
            return this.deliverysites.find((item) => {
                return item.id == this.deliverysite_id;
            });
        },
        order_typechoices() {
            return [
                {
                    text: this.$translate("labels.noDelivery"),
                    value: "no_delivery",
                },
                {
                    text: this.$translate("labels.warehousePickup"),
                    value: "pickup",
                },
                {
                    text: this.$translate("labels.shipping"),
                    value: "shipping",
                },
            ];
        },
        canSave() {
            if (!this.buyer_id || this.buyer_id === "new") {
                return false;
            }

            if (
                this.order_type == "shipping" &&
                !this.deliverysite_id
            ) {
                return false;
            }

            if (this.order.order_date == null) {
                return false;
            }
            return true;
        },
        title() {
            return this.params.order.id
                ? this.$translate("title.editOrder")
                : this.$translate("title.newOrder");
        },
        isNew() {
            return !this.order.id;
        },
        showAssignToField() {
            if (this.params.order?.parent) return false;
            return this.current_user_is_owner || !this.params.order?.ready;
        },
        showDeliveryInstructionsWarning() {
            // Show warning only for existing orders (not new) and when delivery instructions have changed
            if (!this.order.id || this.order.readonly) return false;
            return (
                this.order.delivery_instructions !==
                this.params.order.delivery_instructions
            );
        },
    },
    mounted() {
        this.initOrder(this.params.order);
    },
    methods: {
        ...mapActions("mcl", ["hideModal"]),
        ...mapMutations("editcustomerorder", [
            "updateDeliverySite",
            "updateDeliverySiteId",
            "updateDeliveryDate",
            "updateOrderDate",
        ]),
        ...mapActions("editcustomerorder", [
            "setBuyer",
            "setDeliverySiteId",
            "setOrderType",
            "initOrder",
            "fetchDeliverySites",
            "fetchDeliverySite",
            "fetchBuyers",
            "saveOrder",
        ]),
        setBuyerIdAction(customer_id) {
            if (customer_id == "new") {
                this.showModal({
                    component: CreateCustomer,
                    params: {
                        customer: {},
                    },
                }).then((result) => {
                    if (result) {
                        this.fetchBuyers();
                        this.setBuyer(result);
                    }
                });
            } else {
                if (customer_id) {
                    this.setBuyer(
                        this.buyers.find((customer) => customer.id == customer_id)
                    );
                }
                if (customer_id) {
                    //this.fetchDeliverySites();
                }
            }
        },
        setBuyerAction(buyer) {
            this.setBuyer(buyer);
        },
        setOrderTypeAction(order_type) {
            this.setOrderType(order_type);
        },
        goToCustomerInvoices() {
            this.hideModal();
            this.$router.push({
                name: "customer",
                params: { customer_id: this.buyer_id },
                query: { section: "invoices" },
            });
        },
        async fetchOverdueInvoicesStatsForBuyer() {
            const id = this.buyer_id;
            if (
                !id ||
                id === "new" ||
                !this.userHasPermission("billing.view_invoice")
            ) {
                this.overdue_invoices_stats = null;
                return;
            }
            try {
                const response = await this.$axios.get(
                    "/api/customerinvoices/stats/",
                    {
                        params: {
                            billed: id,
                            paid: false,
                            due: true,
                        },
                    }
                );
                this.overdue_invoices_stats = response.data;
            } catch {
                this.overdue_invoices_stats = null;
            }
        },

        async setDeliverySiteIdAction(deliverysite_id) {
            if (deliverysite_id == "new") {
                const result = await this.showModal({
                    component: DeliverySiteModal,
                    params: {
                        deliverysite: {
                            customer: this.buyer_id,
                            customer_data: this.buyers.find(
                                (customer) => customer.id == this.buyer_id
                            ),
                        },
                    },
                });
                this.fetchDeliverySites();
                if (result) {
                    this.setDeliverySiteId(result.id);
                } else {
                    this.setDeliverySiteId(null);
                    return false;
                }
            } else {
                if (deliverysite_id) {
                    this.updateDeliverySite(
                        this.deliverysites.find(
                            (deliverysite) => deliverysite.id == deliverysite_id
                        )
                    );
                }
            }
        },
        async editSite() {
            const result = await this.showModal({
                component: DeliverySiteModal,
                params: { deliverysite: this.activeDeliverySite },
            });
            if (result) {
                this.fetchDeliverySites();
            }
        },
        updateAssignedTo(user) {
            // Persist null explicitly so JSON keeps "assigned_to": null on PUT.
            if (user == null) {
                this.order.assigned_to = null;
                this.order.assigned_to_data = null;
                return;
            }
            this.order.assigned_to = user.id ?? null;
            this.order.assigned_to_data = user;
        },

        async saveInformationClicked() {
            try {
                let updateShipmentDates = false;
                if (this.order_type !== "no_delivery" && this.order.id && this.delivery_date && this.delivery_date !== this.params.order.delivery_date) {
                    const choice = await this.$swal({
                        title: this.$translate("shipmentDatesTitle"),
                        text: this.$translate("shipmentDatesText"),
                        type: "question",
                        showDenyButton: true,
                        showCancelButton: true,
                        confirmButtonText: this.$translate("updateShipmentDates"),
                        denyButtonText: this.$translate("keepShipmentDates"),
                        cancelButtonText: this.$translate("cancelDateSave"),
                    });
                    if (choice.dismiss) return;
                    updateShipmentDates = !choice.isDenied;
                }
                const response = await this.saveOrder({ updateShipmentDates });
                if (response.status == 201) {
                    this.addAlert(this.$translate("messages.orderCreated"));
                } else {
                    this.addAlert(this.$translate("messages.orderUpdated"));
                }
                this.hideModal({ result: response.data });
            } catch (error) {
                this.$swal({
                    title: this.$translate("messages.failedSavingOrder"),
                    html: this.$utils.resultToSwalContent(this, error),
                    type: "error",
                });
            }
        },
    },
    watch: {
        buyer_id: {
            handler(newId) {
                this.fetchOverdueInvoicesStatsForBuyer();
            },
            immediate: true,
        },
    },
    i18n: {
        messages: {
            en: {
                noDeliverySite:
                    "No delivery address available. Please contact the customer to provide a delivery address.",
                orderSection: "Order",
                shippingSection: "Shipping",
                selectCustomerForShipping: "Select a customer",
                selectCustomerForShippingHint: "Choose a customer on the left to configure shipping.",
                orderDateLabel: "Order date",
                shipmentDatesTitle: "Update shipment dates too?",
                shipmentDatesText: "Apply the requested delivery date to editable pending shipments? Completed shipments and past dates managed by an external warehouse are excluded.",
                updateShipmentDates: "Update shipments too",
                keepShipmentDates: "Keep shipment dates",
                cancelDateSave: "Cancel",
                delivery_update_warning:
                    "This change will be applied to pending shipments and future ones.",
                labels: {
                    deliveryDate: "Requested delivery date",
                    pickupDate: "Requested pickup date",
                    deliveryMode: "Delivery mode",
                    deliverySite: "Delivery site",
                    defaultDeliverySite: "default site",
                    noDelivery: "No delivery",
                    warehousePickup: "Pickup at warehouse",
                    shipping: "Shipping",
                    comments: "Comments",
                    delivery_instructions: "Delivery instructions",
                    notes: "Internal notes",
                    selectDate: "Select date",
                    assignedTo: "Assigned to",
                    unassigned: "Unassigned",
                },
                placeholders: {
                    delivery_instructions:
                        "Instructions to transmit to the logistician",
                    comments: "Comments shared with the customer",
                    notes: "Internal notes",
                },
                buttons: {
                    cancel: "Cancel",
                    createOrder: "Create order",
                    saveOrder: "Save order",
                    createNewCustomer: "Create new customer",
                    createNewSite: "Create new site",
                    addComments: "Add comments",
                    addDeliveryInstructions: "Add delivery instructions",
                    addNotes: "Add internal notes",
                },
                editSite: "Edit site",
                title: {
                    editOrder: "Edit order",
                    newOrder: "New order",
                },
                messages: {
                    orderCreated: "Order created",
                    orderUpdated: "Order updated",
                    failedSavingOrder: "Failed saving order",
                },
                overdueUnpaidInvoicesWarningCompact:
                    "This customer has {{count}} overdue unpaid invoice(s) ({{amount}} € incl. VAT).",
                view: "View",
            },

            fr: {
                noDeliverySite:
                    "Aucune adresse de livraison disponible. Veuillez contacter le client pour qu'il renseigne son adresse de livraison.",
                orderSection: "Commande",
                shippingSection: "Expédition",
                selectCustomerForShipping: "Sélectionnez un client",
                selectCustomerForShippingHint: "Choisissez un client à gauche pour configurer l’expédition.",
                orderDateLabel: "Date de commande",
                shipmentDatesTitle: "Modifier aussi les dates des expéditions ?",
                shipmentDatesText: "Appliquer la date de livraison souhaitée aux expéditions en attente modifiables ? Les expéditions terminées et les dates passées gérées par un entrepôt externe sont exclues.",
                updateShipmentDates: "Modifier aussi les expéditions",
                keepShipmentDates: "Conserver leurs dates",
                cancelDateSave: "Annuler",
                delivery_update_warning:
                    "Cette modification sera appliquée aux expéditions en attente ainsi qu'aux futures expéditions.",
                labels: {
                    deliveryDate: "Date de livraison souhaitée",
                    pickupDate: "Date d’enlèvement souhaité",
                    deliveryMode: "Mode de livraison",
                    deliverySite: "Site de livraison",
                    defaultDeliverySite: "site par défaut",
                    noDelivery: "Pas de livraison",
                    warehousePickup: "Enlèvement à l'entrepôt",
                    shipping: "Expédition",
                    comments: "Commentaires",
                    selectDate: "Sélectionner une date",
                    assignedTo: "Attribué à",
                    unassigned: "Automatique",
                    delivery_instructions: "Instructions de livraison",
                    notes: "Notes",
                },
                placeholders: {
                    delivery_instructions:
                        "Entrez ici les instructions spécifiques à cette commande à transmettre au logisticien",
                    comments:
                        "Entrez ici les commentaires à partager avec le client",
                    notes: "Entrez ici les notes internes. Elles ne seront pas partagées avec le client ou le logisticien.",
                },
                buttons: {
                    cancel: "Annuler",
                    createOrder: "Créer la commande",
                    saveOrder: "Enregistrer la commande",
                    createNewCustomer: "Créer un nouveau client",
                    createNewSite: "Créer un nouveau site",
                    addComments: "Ajouter des commentaires",
                    addDeliveryInstructions:
                        "Ajouter des instructions de livraison",
                    addNotes: "Ajouter des notes internes",
                },
                editSite: "Modifier le site",
                title: {
                    editOrder: "Modifier la commande",
                    newOrder: "Nouvelle commande",
                },
                messages: {
                    orderCreated: "Commande créée",
                    orderUpdated: "Commande mise à jour",
                    failedSavingOrder: "Échec de l'enregistrement de la commande",
                },
                overdueUnpaidInvoicesWarningCompact:
                    "Ce client a {{count}} facture(s) échue(s) non payée(s) ({{amount}} € TTC).",
                view: "Voir",
            },
        },
    },
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/_stitch-modal.scss";
@import "@/assets/css/_settings-reference.scss";
@import "@/assets/css/_logistics-modal.scss";

@import "@/assets/css/_order-modal.scss";
</style>
